<template>
	<div>
		<compFormEdit
			align="center"
			:formdata="getBase"
			v-model="formData"
			ref="form"
			class="margin-top-15"
		></compFormEdit>
		<footer class="text-right">
			<vButton class="margin-5" theme="success" @click="updateItemData">保存</vButton>
		</footer>
		<vLoading size="large" transfer :loading="loading"></vLoading>
	</div>
</template>

<script>
import { HttpDdSystems, HttpUclocaleStructRead, HttpUclocaleStructUpdate } from '@/service/ucadm';
export default {
	props: ['params', 'type'],
	components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormEdit: () => import("@components/templates/formedit"),
	},
	data() {
		return {
			loading: false,
			formData: {
				"langKey": "",
				"zh-CN": "",
				"en": "",
				"systemId": 0,
				// "locales": [
				// 	{
				// 		"locale": "zh_CN",
				// 		"langValue": ""
				// 	},
				// 	{
				// 		"locale": "en",
				// 		"langValue": ""
				// 	}
				// ]
			},
			sysList: [],
		};
	},
	created() {
		this.getSyslist();
		this.getItemData();
	},
	computed: {
		getBase() {
			const query = this.type === 'edit';
			return [
				{
					label: '标识',
					key: 'langKey',
					span: 18,
					query,
					// props:{
					// 	placeholder:"xxx.xxx.xxx"
					// },
					formItem: {
						rules: {
							validator(rule, value, callback) {
								if (value && (/[\w-]+\.[\w-]+\.[\w-]+/ig.test(value))) {
									callback()
								} else {
									callback(new Error('请规范填写'))
								}
							}
						}
					}
				},
				{
					label: '中文',
					key: 'zh-CN',
					span: 18,
				},
				{
					label: 'English',
					key: 'en',
					span: 18,
				},
				{
					label: "所属系统",
					tag: "vSelect",
					key: "systemId",
					options: this.sysList,
					span: 18,
					query,
					valueText: (this.sysList.find((item) => {
						return this.formData.systemId === item.value
					}) || {}).label
				},
			]
		},
	},
	methods: {
		handleResponse(data) {
			const { langKey, locales = [], systemId } = data;
			this.formData = { langKey, systemId };
			locales.forEach(item => {
				this.formData[item.locale] = item.langValue
			});
		},
		handleRequest() {
			const { langKey, en, systemId } = this.formData;
			return {
				langKey,
				locales: [
					{
						locale: "zh-CN",
						langValue: this.formData['zh-CN'],
					},
					{
						locale: "en",
						langValue: en,
					}
				],
				systemId
			}
		},
		async getSyslist() {
			const response = await HttpDdSystems();
			if (response) {
				this.sysList = (response.data || []).map(function (item) {
					return {
						value: item.id,
						label: `${item.label}(${item.title})`
					}
				});
			}
		},
		async updateItemData() {
			const vaild = await this.$refs.form.validate();
			if (!vaild) return;
			this.loading = true;
			const formData = this.handleRequest();
			const response = await HttpUclocaleStructUpdate(formData).catch(err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			});
			if (response) {
				this.loading = false;
				this.$emit('on-close');
				this.$emit('on-update');
				this.$VMessage.success(response.message);
			}
		},
		async getItemData() {
			if (this.type !== 'edit') return;
			this.loading = true;
			const response = await HttpUclocaleStructRead(this.params).catch(err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			});
			if (response) {
				this.loading = false;
				this.handleResponse(response.data || {})
			}
		},
	},
};
</script>
